import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

interface BackdropProps {
  open: boolean;
  onOpen?: () => void;
  onClose: () => void;
  buttonLabel?: string;
  showButton?: boolean;
}

export default function SimpleBackdrop({ open, onClose }: BackdropProps) {
  return (
    <div>
      <Backdrop sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })} open={open} onClick={onClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
